// extracted by mini-css-extract-plugin
module.exports = {"unordereditem":"UnorderedList-module__unordereditem___1P88x","unordered-list":"UnorderedList-module__unordered-list___2aNqk"};